import api from "../api.js";
import store from "@/store/index.js";


const GET_ORG_INFO = async (query, otherParams) => {
  let ojn = {
    OPER: 'LIST',
    DSP_CA: 'APPLET',
    ORG_ID: store.state.smCloud.org_id,
    DSP_LVL: 'ALL',

    STATE_ID: '',
    RANK_ID: '',
    TYPE_ID: '',
    CLS_ID: '1001',

    QRY_TXT: query,
    FZY_YN: 'Y',
    NOW_PAGE: 1,
    PAGE_SIZE: 50,
    ORDER_BY: '',
  }
  let response = await api.smCloud.fSmCloudQueryApi({
    methodName: 'GET_ORG_INFO',
    js: ojn
  })
  //过滤自己
  response.data = response.data.filter(item => item.org_id !== store.state.smCloud.org_id);
  return response.data;
};
export default {
  GET_ORG_INFO, //
};



//////////////////
// WEBPACK FOOTER
// ./common/global/listApi.js
// module id = null
// module chunks = 